import { BaseService } from '../BaseService';
import { createSingleton } from '../singleton';
export default class EntitiesBus extends BaseService {
    static ICommand;
    constructor() {
        super({ error: null, loading: false });
    }
    publishMany(commands) {
        for (let command of commands) {
            const { action, schema_name, table_name } = command;
            //                                                                                     
            const isCUDCommand = action === 'C' || action === 'U' || action === 'D';
            if (isCUDCommand) {
                //                        
                this._notify(`${schema_name}.${table_name}`, [command]); //                               
                this._notify(`${schema_name}.*`, [command]); //                                            
                this._notify(`*.${table_name}`, [command]); //                                         
            }
            if (action === 'R') {
                //                                                                         
                //                                                                  
                //                                                                    
                //                                                                    
                //                                                                      
                //                                                                     
                //                   
                this._notify(`R ${schema_name}.${table_name}`, [command]);
                continue;
            }
            //                             
            this._notify(`${action} ${schema_name}.${table_name}`, [command]);
        }
        //                 
    }
    //                                       
    //      
    //  
    static subscribe(event, listener) {
        return this.getInstance().subscribe(event, listener);
    }
    static unsubscribe(listener) {
        return this.getInstance().unsubscribe(listener);
    }
    static getInstance = createSingleton(() => new EntitiesBus(), '__EntitiesBus');
}
